/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select'
import { EMPTY_IDEA_FILTERS, IDEA_STATUS_OPTIONS } from './constants'
import { areFiltersEqual, hasActiveFilters } from './utils'

/**
 * Filter bar of the Innovate All Ideas list.
 *
 * Idea Status is edited as a draft and sent to the API only on "Apply", so picking several
 * statuses costs one request instead of one per click.
 * Search filters the loaded list as you type (no API call).
 */
const IdeaListFilters = ({
  classes,
  appliedFilters,
  onApply,
  onReset,
  searchTerm,
  onSearchChange,
  disabled = false,
}) => {
  const [draft, setDraft] = useState(appliedFilters)

  // Follow the applied filters when they change from outside (e.g. Reset).
  useEffect(() => {
    setDraft(appliedFilters)
  }, [appliedFilters])

  const isDirty = !areFiltersEqual(draft, appliedFilters)
  const canReset = isDirty || hasActiveFilters(appliedFilters) || Boolean(searchTerm)

  const selectedStatusOptions = useMemo(
    () => IDEA_STATUS_OPTIONS.filter((option) => draft.statuses.includes(option.value)),
    [draft.statuses],
  )

  const handleApply = (event) => {
    event.preventDefault()
    if (isDirty) onApply(draft)
  }

  const handleReset = () => {
    setDraft(EMPTY_IDEA_FILTERS)
    onReset()
  }

  return (
    <form className={classes.filterBar} onSubmit={handleApply} aria-label="Filter ideas">
      <div className={classes.filterField}>
        <label htmlFor="idea-search" className={classes.filterLabel}>Search</label>
        <input
          id="idea-search"
          type="text"
          name="search"
          placeholder="Search by title..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className={classes.filterInput}
        />
      </div>

      <div className={`${classes.filterField} ${classes.statusField}`}>
        <label htmlFor="idea-status-filter" className={classes.filterLabel}>Idea Status</label>
        <Select
          inputId="idea-status-filter"
          isMulti
          options={IDEA_STATUS_OPTIONS}
          value={selectedStatusOptions}
          onChange={(options) => setDraft({ statuses: (options || []).map((o) => o.value) })}
          placeholder="All statuses"
          closeMenuOnSelect={false}
          isDisabled={disabled}
          styles={{
            control: (provided) => ({
              ...provided,
              marginBottom: '0rem',
              borderRadius: '25px',
              // maxWidth: '20rem',
              // height: '3rem', // Increase the height
              fontSize: '1rem', // Increase the font size
              borderWidth: '2px',
              borderColor: '#6551FF', // Change the border color
              // Add more custom styles as needed
            }),
            multiValue: (base) => ({
              ...base,
              // background: 'transparent',
            }),
          }}
        />
      </div>

      <div className={classes.filterActions}>
        <button type="submit" className={classes.applybtn} disabled={disabled || !isDirty}>
          Apply
        </button>
        <button type="button" className={classes.resetbtn} onClick={handleReset} disabled={disabled || !canReset}>
          Reset
        </button>
      </div>
    </form>
  )
}

export default React.memo(IdeaListFilters)